import { CurrencyPipe, DatePipe, PercentPipe } from '@angular/common';
import { Column, GridRow } from '@shared';
import { IChangeset } from '@shared-data';
import { IPricingItem } from './pricing-item.interface';

class ModifierCodesChangeset implements IChangeset, IPricingItem {
  id: string;
  restaurantId: number;
  restaurantNo: string;
  categoryId?: string;
  status?: string;
  availabilityScheduledDate: Date | null;

  @Column({
    field: 'restaurantName',
    title: 'Restaurant',
    order: 0.1,
    width: 80,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: false,
  })
  restaurantName?: string;

  @Column({
    field: 'tierName',
    title: 'Tier',
    order: 0,
    width: 160,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: true,
    align: 'left',
  })
  tierName?: string;

  @Column({
    field: 'categoryName',
    title: 'Category',
    order: 0,
    width: 150,
    sortable: true,
    hidden: true,
    filterable: true,
    filterType: 'text',
    align: 'left',
  })
  categoryName?: string;

  @Column({
    field: 'parItemId',
    title: 'Brink ID',
    order: 2,
    width: 120,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  parItemId: string;

  @Column({
    field: 'itemName',
    title: 'Product',
    order: 1,
    width: 100,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName: string;

  // @Column({
  //   group: 'Add',
  //   field: 'itemPrice',
  //   title: 'Current Modifier Price',
  //   order: 3,
  //   width: 150,
  //   pipeToken: CurrencyPipe,
  //   filterable: true,
  //   filterType: 'numeric',
  //   type: 'number',
  //   fixed: true,
  //   sortable: true,
  //   visibleInQuickView: true,
  // })
  itemPrice?: number;

  // @Column({
  //   group: 'Add',
  //   field: 'newPrice',
  //   title: 'New Modifier Price',
  //   order: 3,
  //   width: 150,
  //   pipeToken: CurrencyPipe,
  //   filterable: true,
  //   filterType: 'numeric',
  //   type: 'number',
  //   fixed: true,
  //   sortable: true,
  //   editable: true,
  //   visibleInQuickView: true,
  // })
  newPrice?: number;

  @Column({
    group: 'Extra',
    field: 'itemPriceExtra',
    title: 'Current Modifier Price',
    order: 3,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  itemPriceExtra?: number;

  @Column({
    group: 'Light',
    field: 'itemPriceLight',
    title: 'Current Modifier Price',
    order: 4,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
  })
  itemPriceLight?: number;

  // @Column({
  //   group: 'None',
  //   field: 'itemPriceNone',
  //   title: 'Current Modifier Price',
  //   order: 3,
  //   width: 150,
  //   pipeToken: CurrencyPipe,
  //   filterable: true,
  //   filterType: 'numeric',
  //   type: 'number',
  //   fixed: true,
  //   sortable: true,
  //   visibleInQuickView: true,
  // })
  itemPriceNone?: number;

  @Column({
    group: 'Extra',
    field: 'newPriceExtra',
    title: 'New Modifier Price',
    order: 4,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    editable: true,
    visibleInQuickView: true,
  })
  newPriceExtra?: number;

  @Column({
    group: 'Light',
    field: 'newPriceLight',
    title: 'New Modifier Price',
    order: 4,
    width: 150,
    pipeToken: CurrencyPipe,
    filterable: true,
    filterType: 'numeric',
    type: 'number',
    fixed: true,
    sortable: true,
    editable: true,
    visibleInQuickView: true,
  })
  newPriceLight?: number;


  // @Column({
  //   group: 'None',
  //   field: 'newPriceNone',
  //   title: 'New Modifier Price',
  //   order: 4,
  //   width: 150,
  //   pipeToken: CurrencyPipe,
  //   filterable: true,
  //   filterType: 'numeric',
  //   type: 'number',
  //   fixed: true,
  //   sortable: true,
  //   editable: true,
  //   visibleInQuickView: true,
  // })
  newPriceNone?: number;

  @Column({
    field: 'pricingScheduledDate',
    hidden: true,
    title: 'Scheduled Date',
    order: 13,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  pricingScheduledDate: Date | null;

  type: string = 'pricing';
 
  @Column({
    field: 'lastModPricingInstore',
    hidden: true,
    title: 'Last Modified Pricing',
    order: 13,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModPricingInstore?: Date;

  isDeliveryAvailable?: boolean;

  constructor(changeset?: Partial<ModifierCodesChangeset>) {
    this.id = changeset?.id || '';
    this.restaurantId = changeset?.restaurantId ?? 0;
    this.restaurantNo = changeset?.restaurantNo ?? '';
    this.itemName = changeset?.itemName ?? '';
    this.categoryId = changeset?.categoryId;
    this.parItemId = changeset?.parItemId ?? '';
    this.pricingScheduledDate = changeset?.pricingScheduledDate ?? null;
    this.categoryName = changeset?.categoryName;
    this.status = changeset?.status;
    this.itemPrice = changeset?.itemPrice;
    this.newPrice = changeset?.newPrice;
    this.itemPriceExtra = changeset?.itemPriceExtra;
    this.itemPriceLight = changeset?.itemPriceLight;
    this.itemPriceNone = changeset?.itemPriceNone;
    this.newPriceExtra = changeset?.newPriceExtra;
    this.newPriceLight = changeset?.newPriceLight;
    this.newPriceNone = changeset?.newPriceNone;
    this.lastModPricingInstore = changeset?.lastModPricingInstore;
    this.availabilityScheduledDate = changeset?.availabilityScheduledDate ?? null;
    this.tierName = changeset?.tierName;
    this.restaurantName = changeset?.restaurantName;
    this.isDeliveryAvailable = changeset?.isDeliveryAvailable;
  }
}

export class GridRowModifierCodesChangeset extends GridRow(ModifierCodesChangeset) {}
